import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 4.51 2.76',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M2.79,2H2.55A.06.06,0,0,1,2.49,2a.07.07,0,0,1,.07-.06,6.3,6.3,0,0,0,1.38-.08c.22-.05.37-.13.42-.24a.26.26,0,0,0,0-.23c-.09-.2-.75-.37-1.08-.4a7.11,7.11,0,0,0-2.22.12A.07.07,0,0,1,1,1L.6.47.13.44C.22.9.4,1.59.58,1.68h0a1.67,1.67,0,0,0,.73.16.07.07,0,0,1,.06.07s0,.05-.07.05a1.77,1.77,0,0,1-.77-.17h0C.22,1.63,0,.52,0,.39s0,0,0,0a0,0,0,0,1,0,0l.58,0s0,0,0,0l.38.55A8.16,8.16,0,0,1,3.29.82c.26,0,1,.18,1.18.48a.38.38,0,0,1,0,.33.74.74,0,0,1-.51.3A5.75,5.75,0,0,1,2.79,2Z"
        />
        <path
          fill={fill}
          d="M1.49,2.76H.59a.07.07,0,0,1,0,0s0-.05,0-.06L1.7,1.39a.06.06,0,0,1,.08,0,.05.05,0,0,1,0,.08L.73,2.64h.74l1.6-1.19a.07.07,0,0,1,.09,0,.06.06,0,0,1,0,.08L1.53,2.75Z"
        />
        <path
          fill={fill}
          d="M1.57,1,1.52,1,.76.1A0,0,0,0,1,.75,0,.05.05,0,0,1,.8,0h.93L2.83.8a.05.05,0,0,1,0,.08.05.05,0,0,1-.08,0L1.68.12H.94l.67.75a.05.05,0,0,1,0,.08Z"
        />
        <path
          fill={fill}
          d="M4.07,1.54a1.07,1.07,0,0,1-.6-.11c-.17-.19.11-.5.15-.53A.06.06,0,0,1,3.7.9,0,0,0,0,1,3.7,1c-.08.09-.22.28-.14.36a2,2,0,0,0,.88.07s.06,0,.07.05a.09.09,0,0,1-.06.07Z"
        />
        <path
          fill={fill}
          d="M.52.73H.12A.05.05,0,0,1,.06.67.06.06,0,0,1,.12.61h.4A.06.06,0,0,1,.58.67.05.05,0,0,1,.52.73Z"
        />
        <path
          fill={fill}
          d="M.46,1.05H.2A.07.07,0,0,1,.13,1,.07.07,0,0,1,.2.93H.46A.07.07,0,0,1,.53,1,.07.07,0,0,1,.46,1.05Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
